define(function(require,exports,module){
    //海囤全球首页tab
    var handleTab = function(options) {
        var id = options.id;

        var ulObj = $("#" + id);
        init(ulObj);

        ulObj.children().hover(function() {
            var self = $(this);
            setTimeout(function() {
                self.siblings().removeClass("curr");

                changeSideImg(self);

                var leafId = self.find("a").attr("data-href");

                self.addClass("curr");
                $(leafId).css("display", "block").siblings().css("display", "none");
            }, 100);
        });
    };

    function init(ulObj) {
        var defaultLi = ulObj.children().eq(0);
        defaultLi.addClass("curr");

        changeSideImg(defaultLi);

        var leafId = defaultLi.find("a").attr("data-href");
        $(leafId).css("display", "block");
    }

    function changeSideImg(liObj) {
        var dataInput = liObj.find("input[type='hidden']");
        var leftImgUrl = dataInput.attr("leftImgUrl") || "";
        var rightImgUrl = dataInput.attr("rightImgUrl") || "";
        var leftTextUrl = dataInput.attr("leftTextUrl") || "";
        var rightTextUrl = dataInput.attr("rightTextUrl") || "";
        if(leftImgUrl != "") {
            $(".state-block .left-img").css({
                "background-image": "url("+leftImgUrl+")", 
                "background-repeat": "no-repeat",
                "cursor": "pointer"
            });
        } else {
            $(".state-block .left-img").css({
                "background-image": "url(//img14.360buyimg.com/movie/jfs/t1879/174/250085225/1125/e7c2f992/55fa79b7N18334239.jpg)",
                "background-repeat": "repeat",
                "cursor": "default"
            });
        }

        if(leftTextUrl != "") {
            $(".state-block .left-img").attr({"href": leftTextUrl, "target": "_blank"});
        } else {
            $(".state-block .left-img").attr("href", "javascript:;").removeAttr("target");
        }

        if(rightImgUrl != "") {
            $(".state-block .right-img").css({
                "background-image": "url("+rightImgUrl+")", 
                "background-repeat": "no-repeat",
                "cursor": "pointer"
            });
        } else {
            $(".state-block .right-img").css({
                "background-image": "url(//img14.360buyimg.com/movie/jfs/t1879/174/250085225/1125/e7c2f992/55fa79b7N18334239.jpg)",
                "background-repeat": "repeat",
                "cursor": "default"
            });
        }

        if(rightTextUrl != "") {
            $(".state-block .right-img").attr({"href": rightTextUrl, "target": "_blank"});
        } else {
            $(".state-block .right-img").attr("href", "javascript:;").removeAttr("target");
        }

    }

    //自营频道首页tab
    var selfTab = {
        init: function() {
            var self = this;
            self.setArrowPoxiX();
            self.handleMove();
        },
        getPosiX: function() {
            var middle = 0;
            $("#cj-selfTab .t-items").find(".t-item").each(function() {
                if($(this).hasClass("curr")) {
                    var iLength = 0;
                    if($(this).find("i").length > 0) {
                        iLength = $(this).find("i").width() + 4;
                    }
                    middle = $(this).offset().left + ($(this).width() - iLength)/2 - $(this).parent().offset().left - 12;
                }
            });
            return middle;
        },
        setArrowPoxiX: function() {
            var self = this;
            var middle = self.getPosiX();

            $("#cj-selfTab .t-items .arrow-up").css({
                "left": middle,
                "display": "block"
            });
        },
        handleMove: function() {
            var self = this;
            $("#cj-selfTab .t-items").find(".t-item").hover(function() {
                var _this = this;

                $(_this).addClass("curr").siblings().removeClass("curr");
                self.setArrowPoxiX();

                setTimeout(function() {
                    var idx = $(_this).index();
                    $("#cj-selfTab .tab-cnts .item-list").eq(idx).removeClass("hide").siblings().addClass("hide");
                }, 200);

            }, function() {});
        }
    };

    exports.handleTab = handleTab;
    exports.fn = selfTab;
});


// WEBPACK FOOTER //
// ./src/js/unit/tab/tab.js